import React, { useState } from 'react'

import Dialog from 'components/Dialog'
import Link from 'components/Link'
import ReviewMethodologyModal from 'components/ReviewMethodologyModal'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

const MethodologyModal = ({ dateRange }) => {
  const [isOpen, setOpen] = useState(false)
  const { sendEvent } = useEventContext({
    name: 'engagement_product_click',
    engagementComponent: 'product_pricing',
    engagementDestination: 'value-for-money-methodology',
  })
  const handleOpen = () => {
    setOpen(true)
    sendEvent({
      engagementDetails: 'open_value-for-money-methodology',
    })
  }

  const handleClose = () => {
    setOpen(false)
    sendEvent({
      engagementDetails: 'close_value-for-money-methodology',
    })
  }

  return (
    <div>
      <Typography>
        <Link onClick={handleOpen}>Learn more how these insights were generated</Link>, and{' '}
        <ReviewMethodologyModal linkText="read more about our reviews." targetComponent="user-opinions-pricing" />
      </Typography>
      <Dialog title="How were these insights generated?" onClose={handleClose} isOpen={isOpen} isSeoFriendly>
        <p>
          The user-sourced insights below are based on reviews published on <b>GetApp</b> {dateRange}, so they
          don&apos;t take into account feedback from reviews left before or after those dates. Reviews represent the
          opinions and points of view expressed by reviewers, not those of <b>GetApp</b>. <b>GetApp</b> neither endorses
          nor makes any warranties about the accuracy or completeness of the information provided by reviewers.
        </p>
      </Dialog>
    </div>
  )
}

export default MethodologyModal
